/** @format */

import {ArchivedOrdersContext, archivedOrdersDefaultState} from './archived_orders_context';
import React, {useState, useEffect} from 'react';
import update from 'immutability-helper';
import SuperAgent from 'superagent';

function ArchivedOrdersContextProvider({children}) {
    const [state, setState] = useState(archivedOrdersDefaultState);

    useEffect(() => {
        SuperAgent.get('/account/orders/archived')
            .set('accept', 'application/json')
            .end((err, response) => {
                setState({
                    loading: false,
                    carts: response.body.archivedOrders
                });
            });
    }, []);

    function handleRemoveOrderFromList(orderId) {
        const updatedCarts = state.carts.filter(cart => cart.id !== orderId);

        setState({
            carts: updatedCarts
        });
    }

    function handleToggleArchiveUnarchiveDesign(cartId, designOrderId, isArchiving) {
        const findCartIndex = state.carts.findIndex(cart => cart.cart_id === cartId);
        const findDesignsOrdersIndex = state.carts[findCartIndex].designs_orders.findIndex(
            designOrder => designOrder.design_id === designOrderId
        );

        const updateTarget = {
            carts: {
                [findCartIndex]: {
                    designs_orders: {
                        [findDesignsOrdersIndex]: {
                            design: {
                                is_archived: {$set: isArchiving}
                            }
                        }
                    }
                }
            }
        };

        setState(update(state, updateTarget));
    }

    return (
        <ArchivedOrdersContext.Provider
            value={{state, handleToggleArchiveUnarchiveDesign, handleRemoveOrderFromList}}>
            {children}
        </ArchivedOrdersContext.Provider>
    );
}

const useArchivedOrdersContext = () => {
    const context = React.useContext(ArchivedOrdersContext);
    if (context === undefined) {
        throw new Error('useArchivedOrdersContext must be used within a ArchivedOrdersProvider');
    }
    return context;
};

export {ArchivedOrdersContextProvider, useArchivedOrdersContext};
